import { ShieldCheck } from "lucide-react";

const ITEMS = ["FSSAI", "USDA Organic", "HACCP", "ISO 22000", "Halal", "Non-GMO"];

const TrustBar = ({ tone = "light" }) => {
  const isDark = tone === "dark";
  return (
    <div
      data-testid="trust-bar"
      className={`border-y ${isDark ? "border-brand-cream/15 bg-brand-black text-brand-cream/80" : "border-brand-green/15 bg-brand-cream text-brand-black/70"}`}
    >
      <div className="container-wide py-5 flex flex-wrap items-center justify-center gap-x-10 gap-y-3">
        <span className={`flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] ${isDark ? "text-brand-gold" : "text-brand-teal"}`}>
          <ShieldCheck size={14} /> Certified
        </span>
        {ITEMS.map((c) => (
          <span key={c} className="font-mono text-[11px] uppercase tracking-[0.18em]">
            {c}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TrustBar;
